



















































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';
import { MoveDirectionEnum } from '@/services/models/Enums';
import FlowMixin from '@/views/reports/forms/flow/mixins/flow-mixin';
import FlowPathErrorsMixin, { RuleError } from '@/views/reports/forms/flow/mixins/flow-path-errors-mixin';

import CreateCampaignDialogFlowRuleErrorsMixin from '@/views/reports/mixins/flow/create-campaign-dialog-flow-rule-errors-mixin';


@Component
export default class FlowNavigationRule extends
  mixins(
    BasicHelperMixin,
    FlowMixin
  ) {
  @Prop()
  item: any;

  @Prop()
  ruleIndex: number;

  @Prop()
  length: number;

  @Prop()
  ruleError: RuleError;

  @Emit('move-rule')
  onMoveRule(index: number, direction: MoveDirectionEnum) {}

  @Emit('expand')
  onExpand(index: number) {}

  get name(): any {
    return this.generate_name(this.item, false, false);
  }

  translatedName(name:string){
    if(name==='Default') return this.t('Default')
    return name
  }
}
